export const downloadJobReport = "PDF Job Report";
export const downloadTimeReport = "PDF Time Sheet";
export const downloadTimeSheet = "Excel Time Sheet";
export const downloadPhotoReport = "PDF Photo Report";
export const downloadNotesPdf = "Notes PDF";
export const downloadTasksPdf = "Tasks PDF";
export const fallbackTitle = "No job name";
